export enum AppNotificationEvents {
  open = 'open',
  openForbiddenError = 'openForbiddenError'
}
